import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick", "data-cy"]
const _hoisted_2 = {
  class: "text-center",
  style: {"width":"64px"}
}
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = ["onClick", "data-cy"]
const _hoisted_6 = {
  class: "text-center",
  style: {"width":"64px"}
}
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"},
  class: "text-right"
}
const _hoisted_8 = {
  key: 1,
  class: "text-right"
}
const _hoisted_9 = {
  key: 2,
  style: {"color":"red"},
  class: "text-right"
}
const _hoisted_10 = {
  key: 3,
  class: "text-right"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick", "data-cy"]
const _hoisted_13 = {
  class: "text-center",
  style: {"width":"64px"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "d-flex",
  style: {"width":"85vw"}
}
const _hoisted_18 = {
  key: 0,
  class: "pb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_VChipTag = _resolveComponent("VChipTag")!
  const _component_HasMailBeenRead = _resolveComponent("HasMailBeenRead")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_VSwitch = _resolveComponent("VSwitch")!
  const _component_InvoiceThemeEdition = _resolveComponent("InvoiceThemeEdition")!
  const _component_Outstanding = _resolveComponent("Outstanding")!
  const _component_ProfileManagement = _resolveComponent("ProfileManagement")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_InvoiceEditWizard = _resolveComponent("InvoiceEditWizard")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_CreateInvoiceProduct = _resolveComponent("CreateInvoiceProduct")!
  const _component_InvoiceProductImport = _resolveComponent("InvoiceProductImport")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                    style: {"border-radius":"16px","overflow":"hidden"},
                    class: "bg-white",
                    id: "Devis"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, {
                        value: "Quotation",
                        href: "#Quotation",
                        "data-cy": "invoiceTable-quotation-tab"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.devis")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "Invoice",
                        href: "#Invoice",
                        "data-cy": "invoiceTable-invoice-tab"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.factures")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "Outstanding",
                        href: "#Outstanding",
                        "data-cy": "invoiceTable-outstanding-tab",
                        disabled: !_ctx.currentUser.showOutStandingClient
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.encours-clients")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_tab, {
                        value: "BillDelivery",
                        href: "#BillDelivery",
                        "data-cy": "invoiceTable-billDelivery-tab"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.bon-de-livraison")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "Product",
                        href: "#Product",
                        "data-cy": "invoiceTable-product-tab",
                        id: "Produits"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.produits")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "Configuration",
                        href: "#Configuration",
                        "data-cy": "invoiceTable-configuration-tab",
                        id: "Configuration"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.configuration")), 1)
                        ]),
                        _: 1
                      }),
                      (
                            !(
                                _ctx.selectedCompany.profile &&
                                _ctx.selectedCompany.profile.managementAuthorization &&
                                _ctx.selectedCompany.profile.managementAuthorizations &&
                                _ctx.selectedCompany.profile.managementAuthorizations.client
                            )
                        )
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 0,
                            value: "Rights",
                            href: "#Rights",
                            "data-cy": "invoiceTable-rights-tab",
                            id: "Rights"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.mes-droits")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_tabs_window, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.activeTab) = $event)),
                    style: {"background-color":"transparent !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: "Quotation" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_primary, {
                                        block: "",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDocument('quotation'))),
                                        "data-cy": "invoice-new-quotation"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.ajouter")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_v_btn_primary, {
                                        block: "",
                                        disabled: !!_ctx.disableConvertInvoicesDialog,
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.convertMultipleInvoiceDialog = true), ["stop"])),
                                        "data-cy": "InvoiceTable-convertInvoice"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.convertir")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])), [
                                        [_directive_tooltip, _ctx.displayDisableConvertInvoicesDialog]
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.activeTab === 'Quotation')
                                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn_primary, {
                                            key: 0,
                                            block: "",
                                            loading: _ctx.synchronisationLoading,
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.retrieveSignatures()), ["stop"])),
                                            "data-cy": "InvoiceTable-synchroniseSignatures"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("invoice-table.synchroniser")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["loading"])), [
                                            [_directive_tooltip, _ctx.$t('invoice-table.recuperer-les-signatures')]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "5",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_filter_bar, {
                                        text: _ctx.search,
                                        "onUpdate:text": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                                        status: _ctx.status,
                                        "onUpdate:status": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status) = $event)),
                                        thirdPartyCompanyName: _ctx.clientCompanyName,
                                        "onUpdate:thirdPartyCompanyName": [
                                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clientCompanyName) = $event)),
                                          _cache[7] || (_cache[7] = ($event: any) => (_ctx.setThirdPartyCompanyName($event)))
                                        ],
                                        "status-list": _ctx.statusList,
                                        companyId: _ctx.selectedCompany.id,
                                        type: "SALES_INVOICE",
                                        onClearFilter: _ctx.clearFilter,
                                        "data-cy": "InvoiceTable-searchQuotation"
                                      }, null, 8, ["text", "status", "thirdPartyCompanyName", "status-list", "companyId", "onClearFilter"])
                                    ]),
                                    _: 1
                                  }),
                                  (!_ctx.$vuetify.display.mobile)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "1",
                                        class: "pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_TutorialButtonDialog, { starterComponents: 'InvoiceTable;' })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_data_table_server, {
                            headers: _ctx.quotationsHeaders,
                            items: _ctx.quotations,
                            page: _ctx.quotationPagination.page,
                            "onUpdate:page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.quotationPagination.page) = $event)),
                            "items-per-page": _ctx.quotationPagination.rowsPerPage,
                            "onUpdate:itemsPerPage": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.quotationPagination.rowsPerPage) = $event)),
                            "items-length": _ctx.quotationPagination.totalItems,
                            "onUpdate:itemsLength": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.quotationPagination.totalItems) = $event)),
                            "sort-by": _ctx.quotationsSortBy,
                            "onUpdate:sortBy": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.quotationsSortBy) = $event)),
                            "items-per-page-options": [10, 25, 50],
                            loading: _ctx.quotationLoading,
                            class: "table rounded-xl",
                            "fixed-header": "",
                            "max-height": "60vh",
                            "multi-sort": false,
                            "data-cy": "InvoiceTable-QuotationTable"
                          }, {
                            item: _withCtx(({ item, index }) => [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'quotationEdition',
                                            params: { companyId: _ctx.companyId, id: item.id },
                                        })
                                    ),
                                "data-cy": `InvoiceTable-quotation_${index}`
                              }, [
                                _createElementVNode("td", _hoisted_2, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedInvoices,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedInvoices) = $event)),
                                    onClick: _withModifiers(() => {}, ["stop"]),
                                    disabled: _ctx.isNotSelectionable(item.id),
                                    class: "pa-0 ma-0",
                                    color: "primary",
                                    value: item.id
                                  }, null, 8, ["modelValue", "disabled", "value"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.title || ""), 1),
                                _createElementVNode("td", null, _toDisplayString(item.client ? item.client.name : "-"), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t(`invoice.${item.status}`)), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VChipTag, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        left: ""
                                      }, {
                                        default: _withCtx(() => _cache[62] || (_cache[62] = [
                                          _createTextVNode("$label")
                                        ])),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(item.status === "DRAFT" ? "Brouillon" : item.number), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.date)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.dueDate)), 1),
                                (_ctx.isVatSubject)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(item.netAmount, undefined)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(item.grossAmount, undefined)), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_HasMailBeenRead, { item: item }, null, 8, ["item"])
                                ])
                              ], 8, _hoisted_1)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "page", "items-per-page", "items-length", "sort-by", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "Invoice" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-3"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.$store.state.invoice.skipWizard)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_menu, {
                                            "open-on-hover": "",
                                            "offset-y": "",
                                            location: "bottom"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_btn_primary, _mergeProps({ block: "" }, props, {
                                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addDocument('invoice'))),
                                                "data-cy": "invoices-new-invoice"
                                              }), {
                                                default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                  _createTextVNode("Ajouter")
                                                ])),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, { nav: "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addDocument('invoice')))
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "x-small" }, {
                                                        default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                          _createTextVNode("$fa-chevron-right")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                          _createTextVNode("Une facture")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item, {
                                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addDocument('invoiceRecurrence')))
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "x-small" }, {
                                                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                          _createTextVNode("$fa-chevron-right")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                          _createTextVNode("Une facture récurrente")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_primary, {
                                            block: "",
                                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addDocument('invoice'))),
                                            "data-cy": "invoiceTable-new-invoice"
                                          }, {
                                            default: _withCtx(() => _cache[68] || (_cache[68] = [
                                              _createTextVNode("Ajouter")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_primary, {
                                        block: "",
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'invoiceMatrixNew',
                                            params: { companyId: _ctx.companyId },
                                        })
                                    )),
                                        "data-cy": "invoiceTable-new-invoiceMatrix"
                                      }, {
                                        default: _withCtx(() => _cache[69] || (_cache[69] = [
                                          _createTextVNode("Matrice")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pl-2"
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "5",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_filter_bar, {
                                        text: _ctx.search,
                                        "onUpdate:text": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.search) = $event)),
                                        status: _ctx.status,
                                        "onUpdate:status": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.status) = $event)),
                                        type: "SALES_INVOICE",
                                        thirdPartyCompanyName: _ctx.clientCompanyName,
                                        "onUpdate:thirdPartyCompanyName": [
                                          _cache[20] || (_cache[20] = ($event: any) => ((_ctx.clientCompanyName) = $event)),
                                          _cache[21] || (_cache[21] = ($event: any) => (_ctx.setThirdPartyCompanyName($event)))
                                        ],
                                        "status-list": _ctx.statusList,
                                        companyId: _ctx.selectedCompany.id,
                                        minPrice: _ctx.minAmount,
                                        "onUpdate:minPrice": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.minAmount) = $event)),
                                        maxPrice: _ctx.maxAmount,
                                        "onUpdate:maxPrice": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.maxAmount) = $event)),
                                        startDate: _ctx.startDate,
                                        "onUpdate:startDate": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.startDate) = $event)),
                                        endDate: _ctx.endDate,
                                        "onUpdate:endDate": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.endDate) = $event)),
                                        onClearFilter: _ctx.clearFilter,
                                        "data-cy": "InvoiceTable-searchInvoice"
                                      }, null, 8, ["text", "status", "thirdPartyCompanyName", "status-list", "companyId", "minPrice", "maxPrice", "startDate", "endDate", "onClearFilter"])
                                    ]),
                                    _: 1
                                  }),
                                  (!_ctx.$vuetify.display.mobile)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        cols: "1",
                                        class: "pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_TutorialButtonDialog, { starterComponents: 'InvoiceTable;' })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_data_table_server, {
                            headers: _ctx.invoicesHeaders,
                            items: _ctx.invoices,
                            page: _ctx.invoicePagination.page,
                            "onUpdate:page": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.invoicePagination.page) = $event)),
                            "items-per-page": _ctx.invoicePagination.rowsPerPage,
                            "onUpdate:itemsPerPage": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.invoicePagination.rowsPerPage) = $event)),
                            "items-length": _ctx.invoicePagination.totalItems,
                            "onUpdate:itemsLength": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.invoicePagination.totalItems) = $event)),
                            "sort-by": _ctx.invoicesSortBy,
                            "onUpdate:sortBy": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.invoicesSortBy) = $event)),
                            "items-per-page-options": [10, 25, 50],
                            loading: _ctx.invoiceLoading,
                            class: "table rounded-xl",
                            "fixed-header": "",
                            "max-height": "60vh",
                            "multi-sort": false,
                            "data-cy": "InvoiceTable-InvoiceTable"
                          }, {
                            item: _withCtx(({ item, index }) => [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'invoiceEdition',
                                            params: { companyId: _ctx.companyId, id: item.id },
                                        })
                                    ),
                                "data-cy": `InvoiceTable-invoice_${index}`,
                                class: "clickable"
                              }, [
                                _createElementVNode("td", _hoisted_6, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedInvoices,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectedInvoices) = $event)),
                                    onClick: _withModifiers(() => {}, ["stop"]),
                                    disabled: _ctx.isNotSelectionable(item.id),
                                    class: "pa-0 ma-0",
                                    color: "primary",
                                    value: item.id
                                  }, null, 8, ["modelValue", "disabled", "value"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.title || "-"), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t(`invoice.type.${item.type}`)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.client ? item.client.name : "-"), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t(`invoice.${item.status}`)), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VChipTag, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        left: ""
                                      }, {
                                        default: _withCtx(() => _cache[70] || (_cache[70] = [
                                          _createTextVNode("$label")
                                        ])),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(item.status === "DRAFT" ? "Brouillon" : item.number), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.date)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.type === "INVOICE"
                                                ? _ctx.formatDate(item.dueDate)
                                                : _ctx.formatDate(item.endDate)), 1),
                                (_ctx.isVatSubject && item.type === 'CREDIT_NOTE')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(item.netAmount, undefined)), 1))
                                  : (_ctx.isVatSubject)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(item.netAmount, undefined)), 1))
                                    : _createCommentVNode("", true),
                                (item.type === 'CREDIT_NOTE')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(item.grossAmount, undefined)), 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(item.grossAmount, undefined)), 1)),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_HasMailBeenRead, { item: item }, null, 8, ["item"])
                                ])
                              ], 8, _hoisted_5)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "page", "items-per-page", "items-length", "sort-by", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "BillDelivery" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_primary, {
                                        block: "",
                                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addDocument('billDelivery'))),
                                        "data-cy": "invoiceTable-new-billDelivery"
                                      }, {
                                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                                          _createTextVNode("Ajouter")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tooltip, null, {
                                        activator: _withCtx(({ props }) => [
                                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                            _createVNode(_component_v_btn_primary, {
                                              block: "",
                                              disabled: !!_ctx.disableConvertInvoicesDialog,
                                              onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.convertMultipleInvoiceDialog = true), ["stop"])),
                                              "data-cy": "InvoiceTable-convertBillDelivery"
                                            }, {
                                              default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                _createTextVNode("Convertir")
                                              ])),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ], 16)
                                        ]),
                                        default: _withCtx(() => [
                                          (_ctx.displayDisableConvertInvoicesDialog)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.displayDisableConvertInvoicesDialog), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "7",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_filter_bar, {
                                        text: _ctx.search,
                                        "onUpdate:text": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.search) = $event)),
                                        status: _ctx.status,
                                        "onUpdate:status": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.status) = $event)),
                                        thirdPartyCompanyName: _ctx.clientCompanyName,
                                        "onUpdate:thirdPartyCompanyName": [
                                          _cache[35] || (_cache[35] = ($event: any) => ((_ctx.clientCompanyName) = $event)),
                                          _cache[36] || (_cache[36] = ($event: any) => (_ctx.setThirdPartyCompanyName($event)))
                                        ],
                                        "status-list": _ctx.statusList,
                                        companyId: _ctx.selectedCompany.id,
                                        type: "SALES_INVOICE",
                                        onClearFilter: _ctx.clearFilter,
                                        "data-cy": "InvoiceTable-billDelivery"
                                      }, null, 8, ["text", "status", "thirdPartyCompanyName", "status-list", "companyId", "onClearFilter"])
                                    ]),
                                    _: 1
                                  }),
                                  (!_ctx.$vuetify.display.mobile)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "1",
                                        class: "pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_TutorialButtonDialog, { starterComponents: 'InvoiceTable;' })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_data_table_server, {
                            headers: _ctx.billDeliveriesHeaders,
                            items: _ctx.billOfDelivery,
                            page: _ctx.billDeliveryPagination.page,
                            "onUpdate:page": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.billDeliveryPagination.page) = $event)),
                            "items-per-page": _ctx.billDeliveryPagination.rowsPerPage,
                            "onUpdate:itemsPerPage": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.billDeliveryPagination.rowsPerPage) = $event)),
                            "items-length": _ctx.billDeliveryPagination.totalItems,
                            "onUpdate:itemsLength": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.billDeliveryPagination.totalItems) = $event)),
                            "sort-by": _ctx.billsDeliverySortBy,
                            "onUpdate:sortBy": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.billsDeliverySortBy) = $event)),
                            "items-per-page-options": [10, 25, 50],
                            loading: _ctx.billDeliveryLoading,
                            class: "table rounded-xl",
                            "fixed-header": "",
                            "max-height": "60vh",
                            "multi-sort": false,
                            "data-cy": "InvoiceTable-BillDeliveryTable"
                          }, {
                            item: _withCtx(({ item, index }) => [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'billDeliveryEdition',
                                            params: { companyId: _ctx.companyId, id: item.id },
                                        })
                                    ),
                                "data-cy": `InvoiceTable-billDelivery_${index}`
                              }, [
                                _createElementVNode("td", _hoisted_13, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.selectedInvoices,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedInvoices) = $event)),
                                    onClick: _withModifiers(() => {}, ["stop"]),
                                    disabled: _ctx.isNotSelectionable(item.id),
                                    class: "pa-0 ma-0",
                                    color: "primary",
                                    value: item.id
                                  }, null, 8, ["modelValue", "disabled", "value"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.client ? item.client.name : "/"), 1),
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`invoice.${item.status}`)) + " ", 1),
                                  (
                                                item.extraData &&
                                                item.extraData.stepCount &&
                                                item.extraData.step < item.extraData.stepCount
                                            )
                                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                        key: 0,
                                        color: "secondary",
                                        height: "10",
                                        "buffer-value": "0",
                                        stream: "",
                                        "model-value": (100 * item.step) / item.stepCount
                                      }, null, 8, ["model-value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VChipTag, { size: "small" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        left: ""
                                      }, {
                                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                                          _createTextVNode("$label")
                                        ])),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(item.status === "DRAFT" ? "Brouillon" : item.number), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.date)), 1)
                              ], 8, _hoisted_12)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "page", "items-per-page", "items-length", "sort-by", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "Product" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "px-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_primary, {
                                        block: "",
                                        onClick: _cache[42] || (_cache[42] = ($event: any) => {
                                        _ctx.productId = '';
                                        _ctx.productDialog = true;
                                    }),
                                        "data-cy": "invoiceTable-newProduct"
                                      }, {
                                        default: _withCtx(() => _cache[74] || (_cache[74] = [
                                          _createTextVNode("Nouveau produit")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "px-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_primary, {
                                        block: "",
                                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.importProductsDialog = true)),
                                        "data-cy": "invoiceTable-importProduct"
                                      }, {
                                        default: _withCtx(() => _cache[75] || (_cache[75] = [
                                          _createTextVNode("Importer produits")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "7",
                                    class: "px-2"
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "1",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.$vuetify.display.mobile)
                                        ? (_openBlock(), _createBlock(_component_TutorialButtonDialog, {
                                            key: 0,
                                            starterComponents: 'InvoiceTable;'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_data_table_server, {
                            headers: _ctx.productHeaders,
                            items: _ctx.products,
                            page: _ctx.productPagination.page,
                            "onUpdate:page": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.productPagination.page) = $event)),
                            "items-per-page": _ctx.productPagination.rowsPerPage,
                            "onUpdate:itemsPerPage": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.productPagination.rowsPerPage) = $event)),
                            "items-length": _ctx.productPagination.totalItems,
                            "onUpdate:itemsLength": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.productPagination.totalItems) = $event)),
                            "sort-by": _ctx.productsSortBy,
                            "onUpdate:sortBy": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.productsSortBy) = $event)),
                            "items-per-page-options": [10, 25, 50],
                            loading: _ctx.productLoading,
                            class: "table rounded-xl",
                            "fixed-header": "",
                            "max-height": "60vh",
                            "multi-sort": false,
                            "data-cy": "InvoiceTable-productTable"
                          }, {
                            item: _withCtx(({ item }) => [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (_ctx.editProduct(item))
                              }, [
                                _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                                _createElementVNode("td", null, [
                                  (item.tag)
                                    ? (_openBlock(), _createBlock(_component_VChipTag, {
                                        key: 0,
                                        class: "text mr-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", {
                                            style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                          }, _toDisplayString(item.tag.name), 5)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(item.title), 1)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.type), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(item.unitPrice, undefined)), 1),
                                (_ctx.isVatSubject)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(item.vatRate) + "%", 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_switch, {
                                    modelValue: item.outDated,
                                    "onUpdate:modelValue": [($event: any) => ((item.outDated) = $event), ($event: any) => (_ctx.setOutDatedProduct(item, $event))],
                                    onClick: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VSwitch, {
                                    "model-value": item.stock,
                                    "onUpdate:modelValue": 
                                                (value) => _ctx.setStockProduct(item.id, value)
                                            ,
                                    onClick: _withModifiers(() => {}, ["stop"]),
                                    disabled: 
                                                (item.accountableAccount &&
                                                    item.accountableAccount.name === '707') ||
                                                (item.stockOperations &&
                                                    !!item.stockOperations.length)
                                            
                                  }, null, 8, ["model-value", "onUpdate:modelValue", "disabled"])
                                ])
                              ], 8, _hoisted_14)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "page", "items-per-page", "items-length", "sort-by", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "Configuration" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InvoiceThemeEdition, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "Outstanding" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Outstanding)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, {
                        value: "Rights",
                        class: "mt-2 rounded"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            rounded: "",
                            class: "pa-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ProfileManagement, {
                                companyId: _ctx.companyId,
                                companyUser: _ctx.companyUser,
                                invoiceMode: true
                              }, null, 8, ["companyId", "companyUser"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        persistent: "",
        modelValue: _ctx.invoiceDialog,
        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.invoiceDialog) = $event)),
        fullscreen: _ctx.$vuetify.display.mobile,
        title: _ctx.dialogTitle,
        actions: _ctx.actions,
        prefixDataCy: "InvoiceTable-valid"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_InvoiceEditWizard, {
              ref: "invoiceEditWizard",
              companyId: _ctx.companyId,
              invoiceType: _ctx.invoiceType,
              invoiceTableMode: true,
              actions: _ctx.actions
            }, null, 8, ["companyId", "invoiceType", "actions"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "fullscreen", "title", "actions"]),
      (_ctx.productDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            persistent: "",
            modelValue: _ctx.productDialog,
            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.productDialog) = $event)),
            "max-width": !_ctx.$vuetify.display.mobile ? '900px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            "hide-overlay": _ctx.$vuetify.display.mobile,
            title: 'Création d\'un produit',
            actions: _ctx.productActions
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CreateInvoiceProduct, {
                id: _ctx.productId,
                companyId: _ctx.companyId,
                saveable: false,
                vatSubject: _ctx.isVatSubject,
                actions: _ctx.productActions,
                onProductSaved: _ctx.onProductSaved
              }, null, 8, ["id", "companyId", "vatSubject", "actions", "onProductSaved"])
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "actions"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.importProductsDialog,
        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.importProductsDialog) = $event)),
        minWidth: _ctx.width,
        title: "Importez vos produits",
        actions: _ctx.importActions
      }, {
        default: _withCtx(() => [
          (_ctx.importProductsDialog)
            ? (_openBlock(), _createBlock(_component_InvoiceProductImport, {
                key: 0,
                ref: "importComponent",
                documentType: 'INVOICE_PRODUCTS',
                actions: _ctx.importActions,
                selectedCompanyId: _ctx.selectedCompany.id,
                onDocumentImported: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onDocumentImported())),
                onWidth: _cache[53] || (_cache[53] = ($event: any) => (_ctx.changeWidth()))
              }, null, 8, ["actions", "selectedCompanyId"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "minWidth", "actions"]),
      (_ctx.convertMultipleInvoiceDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            title: "Conversion",
            modelValue: _ctx.convertMultipleInvoiceDialog,
            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.convertMultipleInvoiceDialog) = $event)),
            class: "px-2",
            "valid-loading": _ctx.convertMultipleInvoiceLoading,
            "valid-disabled": _ctx.selectedInvoicesHaveOptionalLines,
            onValid: _cache[60] || (_cache[60] = ($event: any) => (_ctx.convertInvoice())),
            "previous-display": _ctx.convertMultipleInvoiceDialogStep !== 'default',
            onPrevious: _cache[61] || (_cache[61] = ($event: any) => (_ctx.convertMultipleInvoiceDialogStep = 'default')),
            "data-cy": "InvoiceTable-valid",
            "min-width": "60vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.convertMultipleInvoiceDialogStep,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.convertMultipleInvoiceDialogStep) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "default" }, {
                    default: _withCtx(() => [
                      (_ctx.selectedInvoiceObjects.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Regroupement de toutes les lignes des éléments suivants : "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoiceObjects, (invoiceToConvert, index) => {
                        return (_openBlock(), _createBlock(_component_v_row, {
                          "no-gutters": "",
                          class: "pb-2",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            (_ctx.selectedInvoiceObjects.length > 1)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "1"
                                }, {
                                  default: _withCtx(() => _cache[76] || (_cache[76] = [
                                    _createTextVNode("   " + _toDisplayString(" - "))
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((invoiceToConvert.title || "Sans titre") +
                            (invoiceToConvert.grossAmount
                                ? ", " +
                                  _ctx.newCommonFormatCurrency(invoiceToConvert.grossAmount, undefined)
                                : "")), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                              default: _withCtx(() => [
                                (
                                    invoiceToConvert.lines &&
                                    invoiceToConvert.lines.length &&
                                    invoiceToConvert.lines.some((l) => l.isOptional)
                                )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      dense: "",
                                      rounded: "",
                                      size: "small",
                                      elevation: "0",
                                      color: 
                                    _ctx.invoicesIdHaveBeenChecked.find((e) => e === invoiceToConvert.id)
                                        ? 'secondary'
                                        : 'warning'
                                ,
                                      class: "pl-2",
                                      onClick: ($event: any) => {
                                    _ctx.convertMultipleInvoiceDialogStep = 'manageOptionalLines';
                                    _ctx.invoiceWhichIsManagingOptionalLines = invoiceToConvert;
                                }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { left: "" }, {
                                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                                            _createTextVNode("$fa-exclamation-triangle")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[78] || (_cache[78] = _createTextVNode(" Gérer les lignes 'en option' "))
                                      ]),
                                      _: 2
                                    }, 1032, ["color", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _cache[79] || (_cache[79] = _createElementVNode("div", null, "Voulez-vous générer :", -1)),
                      _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.conversionType,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.conversionType) = $event)),
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            label: "une facture",
                            value: "INVOICE",
                            "data-cy": "InvoiceTable-invoice"
                          }),
                          _createVNode(_component_v_radio, {
                            label: "un devis",
                            value: "QUOTATION",
                            disabled: _ctx.activeTab !== 'Invoice' && _ctx.activeTab !== 'BillDelivery',
                            "data-cy": "InvoiceTable-quotation"
                          }, null, 8, ["disabled"]),
                          _createVNode(_component_v_radio, {
                            label: "un bon de livraison",
                            value: "BILL_DELIVERY",
                            disabled: _ctx.activeTab !== 'Invoice' && _ctx.activeTab !== 'Quotation',
                            "data-cy": "InvoiceTable-billDelivery"
                          }, null, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.convertMultipleInvoiceDialogStep === 'manageOptionalLines')
                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 0,
                        value: "manageOptionalLines"
                      }, {
                        default: _withCtx(() => [
                          _cache[82] || (_cache[82] = _createElementVNode("div", { class: "pb-2" }, " Veuillez choisir les lignes 'en option' à conserver (les autres seront supprimées) ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceWhichIsManagingOptionalLines.lines, (line, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'line_' + index
                            }, [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  (!line.isOptional)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "1"
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "1",
                                        class: "d-flex align-center",
                                        style: {"font-style":"italic","font-size":"0.8em"}
                                      }, {
                                        default: _withCtx(() => _cache[80] || (_cache[80] = [
                                          _createTextVNode("En option")
                                        ])),
                                        _: 1
                                      })),
                                  (!line.isOptional)
                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                        key: 2,
                                        modelValue: _ctx.trueValue,
                                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.trueValue) = $event)),
                                        disabled: "",
                                        color: "primary"
                                      }, null, 8, ["modelValue"]))
                                    : (_openBlock(), _createBlock(_component_v_checkbox, {
                                        key: 3,
                                        modelValue: line.keepTheLine,
                                        "onUpdate:modelValue": ($event: any) => ((line.keepTheLine) = $event),
                                        color: "primary"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field, {
                                        modelValue: line.title,
                                        "onUpdate:modelValue": ($event: any) => ((line.title) = $event),
                                        label: "Titre",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                        disabled: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "1",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field, {
                                        modelValue: line.reference,
                                        "onUpdate:modelValue": ($event: any) => ((line.reference) = $event),
                                        label: "Ref",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                        disabled: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "1",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field, {
                                        modelValue: line.quantity,
                                        "onUpdate:modelValue": ($event: any) => ((line.quantity) = $event),
                                        label: "Qté",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                        disabled: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field, {
                                        modelValue: line.unitPrice,
                                        "onUpdate:modelValue": ($event: any) => ((line.unitPrice) = $event),
                                        label: "Prix unitaire",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                        disabled: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field, {
                                        modelValue: line.netAmount,
                                        "onUpdate:modelValue": ($event: any) => ((line.netAmount) = $event),
                                        label: "Montant HT",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                        disabled: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (index !== _ctx.invoiceWhichIsManagingOptionalLines.lines.length - 1)
                                ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "d-flex justify-end pr-3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    elevation: "0",
                                    dense: "",
                                    rounded: "",
                                    onClick: _cache[57] || (_cache[57] = ($event: any) => {
                                    _ctx.invoicesIdHaveBeenChecked.push(
                                        _ctx.invoiceWhichIsManagingOptionalLines.id,
                                    );
                                    _ctx.convertMultipleInvoiceDialogStep = 'default';
                                })
                                  }, {
                                    default: _withCtx(() => _cache[81] || (_cache[81] = [
                                      _createTextVNode(" OK pour ce devis ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "valid-loading", "valid-disabled", "previous-display"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}